// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"28577362","539":"dbf5782b"}[chunkId] + ".chunk.js";
};